import { render, staticRenderFns } from "./snapshot.vue?vue&type=template&id=46ce9ae8"
import script from "./snapshot.vue?vue&type=script&lang=js"
export * from "./snapshot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports